export default __webpack_public_path__ + "static/media/emptySubjects.e5c475e3.svg";